import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import Phone from "../../assets/img/phone";
import socket from "../../assets/socketConnection";
import { toPersianNum, toSeperatedNum } from "../../assets/utils";
import { fetchCurrentDriverAsync } from "../../redux/currentDriver/currentDriver.actions";
import { selectCurrentDriverInfo } from "../../redux/currentDriver/currentDriver.selectors";
import { fetchLoadLocationAsync } from "../../redux/currentReq/currentReq.actions";
import { selectCurrentReqLoadLocation } from "../../redux/currentReq/currentReq.selectors";
import OnlinePayment from "../onlinePayment/onlinePayment.component";
import ProcessAlert from "../processAlert/processAlert.component";
import { SelectedBitContStyled } from "./SelectedBitFinal4.styles";

const SelectedBitFinal3 = ({
  bit,
  won_price,
  fetchLoadLocationAsync,
  fetchCurrentDriverAsync,
  selectCurrentReqLoadLocation,
  selectCurrentDriverInfo,
}) => {
  // console.log(bit);
  // debugger;
  const { firstname, lastname, profile_img, id } = bit.selected_driver;

  useEffect(() => {
    //   socket.emit("get_driver_location", {
    //     driver: id,
    //     load_id: bit.id,
    //   });

    //   socket.on("my_loads_location", (data) => {
    //     // alert("resp");
    //     console.log(data);

    //     alert("new location");
    //     // updateNextPageMap(data);
    //   });

    fetchLoadLocationAsync(socket, id, bit.id);
    fetchCurrentDriverAsync(socket, bit.id);

    // socket.emit("get_driver_private_info", {
    //   load_id: bit.id,
    // });

    // socket.on("response_driver_private_info", (data) => {
    //   console.log(data);
    //   alert("data");
    //   // LOADS_STATE.currentCardDriver = data;
    //   // console.log(LOADS_STATE.currentCardDriver);
    //   // document.querySelector(
    //   //   "#callDriver-btn"
    //   // ).href = `tel:${LOADS_STATE.currentCardDriver[0].mobile}`;
    // });

    // return () => {
    //   cleanup
    // }
  }, []);
  const { national_plate } = selectCurrentReqLoadLocation;
  // console.log(bit);
  return (
    <SelectedBitContStyled profile_img={profile_img}>
      <div className="selected-bit__title">
        <div className="selected-bit__img">
          {/* {profile_img ? <img src={profile_img} alt="" /> : null} */}
        </div>

        <div className="flex-grow-1">
          <div className="font-weight-bold font-size--2">
            {firstname} {lastname}
          </div>
          <div className="d-flex align-items-center justify-content-between">
            <div>
              {selectCurrentDriverInfo
                ? `${selectCurrentDriverInfo.drivervehicle.vehicle.v_name} ${selectCurrentDriverInfo.drivervehicle.vehicle_category.t_name}`
                : null}
            </div>
            {national_plate ? (
              <div className="selected-bit__pelak">
                <div>{national_plate.location_id}</div>
                <div className="selected-bit__pelak__sep"></div>
                <div>{national_plate.threedigit}</div>
                <div>{national_plate.alphabet_id}</div>
                <div>{national_plate.twodigit}</div>
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <div className="selected-bit__tel font-weight-bold font-size--2 text-center position-relative">
        <a href={`tel:${selectCurrentDriverInfo.mobile}`}>
          {selectCurrentDriverInfo
            ? toPersianNum(selectCurrentDriverInfo.mobile)
            : null}
          <div className="selected-bit__tel__icon">
            <Phone size="15" color="#2a2e43" />
          </div>
        </a>
      </div>

      {/* <button
        className="selected-bit__price w-100"
        onMouseDown={EjectConfirmation}
      >
        تایید تخلیه
        <span className="small"> (بار از راننده تحویل گرفته‌شد)</span>
      </button> */}

      <div className="row mt-4">
        <div className="col-6">
          <a href={`https://sv2.barnet.app/pdfs/${bit.barname}.pdf`}>
            <div className="btn--border text-center">مشاهده فاکتور</div>
          </a>
        </div>
        <div className="col-6">
          {bit.barname_legal ? (
            <a
              href={`https://sv2.barnet.app/uploaded_barname/${bit.barname_legal}.jpg`}
            >
              <div className="btn--border text-center">بارنامه</div>
            </a>
          ) : (
            ""
          )}
        </div>
      </div>

      <ProcessAlert/>

      <OnlinePayment bit={bit} won_price={won_price} />
    </SelectedBitContStyled>
    // "asdf"
  );
};

const mapStateToProps = createStructuredSelector({
  selectCurrentReqLoadLocation: selectCurrentReqLoadLocation,
  selectCurrentDriverInfo: selectCurrentDriverInfo,
});

const mapDispatchToProps = (dispatch) => ({
  fetchLoadLocationAsync: (x, y, z) =>
    dispatch(fetchLoadLocationAsync(x, y, z)),
  fetchCurrentDriverAsync: (x, y) => dispatch(fetchCurrentDriverAsync(x, y)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectedBitFinal3);
